module.exports = __webpack_public_path__ + "officialStatic/img/solutionActive2.3169401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solutionActive2.png
// module id = 5ZzF
// module chunks = 0